/**
 * @generated SignedSource<<b2d3ea9ef31abd71f6c2436fc8fb5dfb>>
 * @relayHash 80fdeb47579d1a9684bee7502dcfaf87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e417de34ba10a08295f1761f71b6cc1bd7cb2cebb45ca848a312e3e2d5c42de8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { SoftwareCapacityContainerBoardFilterQuery } from './SoftwareCapacityContainerBoardFilterQuery.graphql';

const node: PreloadableConcreteRequest<SoftwareCapacityContainerBoardFilterQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "e417de34ba10a08295f1761f71b6cc1bd7cb2cebb45ca848a312e3e2d5c42de8",
    "metadata": {},
    "name": "SoftwareCapacityContainerBoardFilterQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
